export default __webpack_public_path__ + "static/media/initial.2a1f9d0c.png";